<script setup>
import { useDevice } from "#imports";
import { computed } from "vue";
const props = defineProps({
  language: {
    type: String,
    default: "en"
  },
  country: {
    type: String,
    default: "gb"
  },
  cdnUrl: {
    type: String,
    default: ""
  }
});
const { isAndroid, isApple } = useDevice();
const appStoreUrl = computed(
  () => `https://itunes.apple.com/${props.country}/app/chargemap-bornes-de-recharge/id438176982`
);
const playStoreUrl = computed(
  () => `https://play.google.com/store/apps/details?id=com.chargemap_beta.android&hl=${props.language}`
);
</script>

<template>
    <div class="flex gap-3">
        <NuxtLink
            external
            :to="appStoreUrl"
            target="_blank"
            :title="$t('home.download.apple')"
            class="gtm-SousMenuIOS"
            :class="[isApple ? 'block' : 'hidden']"
        >
            <NuxtImg
                class="h-11 lg:h-10"
                :alt="$t('home.download.apple')"
                :src="`${cdnUrl}/images/cmp-store/${language}/app-store-badge.svg`"
            />
        </NuxtLink>
        <NuxtLink
            external
            :to="playStoreUrl"
            target="_blank"
            :title="$t('home.download.google')"
            class="gtm-SousMenuAndroid"
            :class="[isAndroid ? 'block' : 'hidden']"
        >
            <NuxtImg
                class="h-11 lg:h-10"
                :alt="$t('home.download.google')"
                :src="`${cdnUrl}/images/cmp-store/${language}/google-play-badge.png`"
            />
        </NuxtLink>
    </div>
</template>
